var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_11369",
    "data-name": "\\uADF8\\uB8F9 11369",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8246",
    "data-name": "\\uC0AC\\uAC01\\uD615 8246",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_11371",
    "data-name": "\\uADF8\\uB8F9 11371",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19716",
    "data-name": "\\uD328\\uC2A4 19716",
    d: "M24.1,23.95H5.9a.65.65,0,0,1-.65-.65V5.1a.65.65,0,0,1,.65-.65H24.1a.65.65,0,0,1,.65.65V23.3a.65.65,0,0,1-.65.65M6.55,22.65h16.9V5.75H6.55Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19717",
    "data-name": "\\uD328\\uC2A4 19717",
    d: "M19.9,5.75H10.1a.65.65,0,0,1-.547-1l2.3-3.6A.651.651,0,0,1,12.4.85h5.2a.649.649,0,0,1,.548.3l2.3,3.6a.65.65,0,0,1-.548,1m-8.614-1.3h7.427l-1.469-2.3H12.756Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19718",
    "data-name": "\\uD328\\uC2A4 19718",
    d: "M23.862,16.181H5.9a.65.65,0,1,1,0-1.3H23.862a.65.65,0,0,1,0,1.3",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19719",
    "data-name": "\\uD328\\uC2A4 19719",
    d: "M16.949,20.344h-3.9a.65.65,0,0,1,0-1.3h3.9a.65.65,0,1,1,0,1.3",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19720",
    "data-name": "\\uD328\\uC2A4 19720",
    d: "M5.25,29.15a.651.651,0,0,1-.528-1.029l3.732-5.2a.65.65,0,0,1,1.057.758l-3.733,5.2a.647.647,0,0,1-.528.271",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19721",
    "data-name": "\\uD328\\uC2A4 19721",
    d: "M24.75,29.15a.651.651,0,0,1-.529-.271l-3.732-5.2a.65.65,0,0,1,1.056-.758l3.733,5.2a.651.651,0,0,1-.528,1.029",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19722",
    "data-name": "\\uD328\\uC2A4 19722",
    d: "M22.8,26.95H7.2a.65.65,0,0,1,0-1.3H22.8a.65.65,0,0,1,0,1.3",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubway);
export default __webpack_public_path__ + "static/media/iconSubway.ae62a1a3985498a052ec914c3253c792.svg";
export { ForwardRef as ReactComponent };